<div>
  <section class="content-header">
    <h1>
      Tenant Menu Setting
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/tenant/index">
          <i class="fas fa-building"></i> Tenant Manager
        </a>
      </li>
      <li>
        <b>Tenant Menu Setting</b>
      </li>
    </ol>
  </section>
  <section class="content" *ngIf="scope.tenant">
    <div class="row">
      <div class="col-md-4">
        <div class="box box-danger">
          <div class="overlay" *ngIf="scope.wait">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <div class="box-body box-profile">
            <div class="row">
              <div class="col-4">
                <img [src]="scope.tenant.logoImage" class="user-image" />
              </div>
              <div class="col-8 p-0">
                <h3 class="profile-username">
                  {{ scope.tenant.tenantName }}
                </h3>  
                <p class="text-muted tenant_cd">
                  {{ scope.tenant.tenantCd  }}
                </p>  
              </div>
            </div>
           <ul class="list-group list-group-unbordered">
              <li class="list-group-item">
                <div class="item-header pull-left">Address</div>
                <div class="item pull-right">
                  {{ scope.tenant.address }}
                </div>
                <!-- <div class="item pull-right">
                  <mat-form-field class="full-width">
                    <input matInput placeholder="テナント名"  formControlName="tenantName">
                    <mat-icon matSuffix>business</mat-icon>
                  </mat-form-field>
                </div> -->
              </li>
              <li class="list-group-item">
                <div class="item-header pull-left">TEL</div>
                <div class="item pull-right">
                  {{ scope.tenant.tel }}
                </div>
              </li>
              <li class="list-group-item">
                <div class="item-header pull-left">Administrator</div>
                <div class="item pull-right">
                  {{ scope.tenant.mainFamilyName }} {{ scope.tenant.mainFirstName }} 
                </div>
              </li>
              <li class="list-group-item">
                <div class="item-header pull-left">Post</div>
                <div class="item pull-right">
                  {{ scope.tenant.mainPosition }}
                </div>
              </li>
              <li class="list-group-item">
                <div class="item-header pull-left">E Mail</div>
                <div class="pull-right">
                  {{ scope.tenant.mainEmail }}
                </div>
              </li>
            </ul>
            <div class="text-center full-width margin-top-10px">
              <button class="full-width " mat-stroked-button color="warn" (click)="editTenant()">テナント情報を編集</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-8 table-area">
        <div class="box box-danger">
          <div class="overlay" *ngIf="scope.wait">
            <i class="fas fa-spinner fa-spin"></i>
          </div>

          <div class="box-header with-border">
            <h3 class="box-title">Menu</h3>
            <div class="pull-right">
              <button mat-raised-button (click)="save()" color="warn">Save</button>
            </div>

          </div>
          <div class="box-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>
                    <mat-slide-toggle  (change)="allToggle()" [checked]="isAllCehck()"></mat-slide-toggle>
                  </th>
                  <th>
                    Category
                  </th>
                  <th>
                    Name
                  </th>
                  <th>
                    Path
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let menu of scope.menuitems">
                  <td>
                    <!-- <div class="mode"><mat-slide-toggle (change)="modeToggle()" [checked]="mode" >Dark mode</mat-slide-toggle></div> -->
                    <mat-slide-toggle (change)="toggle(menu)" [checked]="menu.select" ></mat-slide-toggle>
                  </td>
                  <td>
                    {{ menu.category }}
                  </td>
                  <td>
                    {{ menu.name }}
                  </td>
                  <td>
                    {{ menu.path }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
